/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
'use memo';
import { pageTypes } from '@/constants/page';
import { ListOptions } from '../ListOptions/ListOptions';
import { type HandleFilterType } from '@/types/filterTypes';
import { useCMSShelfPageConfig } from '@/features/contentstack/hooks/useCMSShelfPageConfig';
import { usePageType } from '@/hooks/usePageType';
import { VisualFilters } from '../VisualFilters';

type Props = {
  refQuickFilter?: React.Ref<HTMLElement>;
  resultsListRef?: React.RefObject<HTMLDivElement | null>;
  onFilterSelect?: (a: HandleFilterType) => void;
};

export const CMSSortingOptions = ({ refQuickFilter, resultsListRef, onFilterSelect }: Props) => {
  const { recordsPerPage, rppOptions } = useCMSShelfPageConfig();
  const { pageType } = usePageType();
  const pageTypeString =
    pageType == pageTypes.search
      ? pageTypes.search
      : pageType == pageTypes.BrandShelf
        ? pageTypes.BrandShelf
        : pageTypes.shelf;

  return (
    <>
      <VisualFilters />
      <ListOptions
        refQuickFilter={refQuickFilter}
        resultsListRef={resultsListRef}
        pageType={pageTypeString}
        onFilterSelect={onFilterSelect}
        rppOptionsData={rppOptions}
        recordsPerPage={recordsPerPage}
        removeMargin
      />
    </>
  );
};
